import React, { Fragment, useContext } from "react";
import { AuthContext } from "../context/auth/AuthContext";
import DetailEklokContainer from "../containers/ekloks/DetailEklokContainer";
import Detail from "../views/ekloks/DetailEklok";
import { Request } from "../api/eklok/Eklok.api";

const EklokPage = ({ item }) => {
  const { token } = useContext(AuthContext);
  const onRefresh = () => {
    Request.refreshEklok(token, item.id);
  };

  return item ? (
    <DetailEklokContainer id={item.id}>
      {({ content }) => (
        <Detail
          onRefresh={onRefresh}
          plant={content.plant ? content.plant : null}
          eklok={content}
        />
      )}
    </DetailEklokContainer>
  ) : (
    <Fragment />
  );
};

export default EklokPage;
